const Blockly = require('blockly');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');
const dataAccessMethods = require('../../../../dataAccessMethods');
const mdcConfig = require('@sstdev/lib_metadata-config');

const { config } = mdcConfig;

const TOOLTIP = 'Add menu item that can be clicked to trigger an action.';

/**
 * @param {*} color
 * @param {import('blockly').Block} blocklyBlock
 */
function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    const workspace = blocklyBlock.workspace;
    const blockId = blocklyBlock.id;

    blocklyBlock.setTooltip(TOOLTIP);
    line1OfInputs
        .appendField('  Icon Name:')
        .appendField(new Blockly.FieldTextInput(''), 'iconName')
        .appendField('  Title:')
        .appendField(new Blockly.FieldTextInput(), 'title')
        .appendField('  Namespace:')
        .appendField(new Blockly.FieldDropdown(dataAccessMethods.getNamespaces), 'namespace')
        .appendField('  Relation:')
        .appendField(new Blockly.FieldDropdown(() => dataAccessMethods.getRelations(workspace, blockId)), 'relation');

    // Load possible actions and default action
    const actionsDropdown = new Blockly.FieldDropdown(config.actionElementActions);
    actionsDropdown.setValue('new');
    line1OfInputs
        .appendField('  For Action:')
        .appendField(actionsDropdown, 'forAction')
        .appendField('  (optional) Subtype:')
        .appendField(new Blockly.FieldTextInput(), 'subtype');
}

/**
 * @param {{[key: string]: any}} code
 * @param {import('blockly').Block} blocklyBlock
 * @return {{[key: string]: any}}
 */
function convertCustomFieldsToCode(code, blocklyBlock) {
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);
    addCodeProperties(['title', 'namespace', 'iconName', 'relation', 'forAction', 'subtype']);
    return code;
}
module.exports = { addBlockSpecificFields, convertCustomFieldsToCode };
